(function () {
  'use strict';

  if (window.FellinoraVetScienceLoaded) {
    return;
  }

  window.FellinoraVetScienceLoaded = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  document.documentElement.classList.add('fv-science-js');

  function setRevealDelays(section) {
    var items = section.querySelectorAll('[data-fv-science-reveal]');

    items.forEach(function (item, index) {
      item.style.setProperty('--fv-science-delay', Math.min(index * 110, 880) + 'ms');
    });
  }

  function isInViewport(section) {
    var rect = section.getBoundingClientRect();
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    var visibleHeight = Math.min(rect.bottom, viewportHeight) - Math.max(rect.top, 0);

    return visibleHeight > 0;
  }

  function showSection(section) {
    if (section.classList.contains('fv-science-is-visible') || section.dataset.fvScienceRevealQueued === 'true') {
      return;
    }

    section.dataset.fvScienceRevealQueued = 'true';

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        section.classList.add('fv-science-is-visible');
        section.dataset.fvScienceRevealQueued = 'done';
      });
    });
  }

  function queueInitialReveal(section) {
    function run() {
      if (isInViewport(section)) {
        showSection(section);
      }
    }

    if (document.readyState === 'complete') {
      requestAnimationFrame(function () {
        requestAnimationFrame(run);
      });
      return;
    }

    window.addEventListener('load', function () {
      requestAnimationFrame(function () {
        requestAnimationFrame(run);
      });
    }, { once: true });
  }

  function reveal(section) {
    setRevealDelays(section);

    if (reduceMotion.matches || !('IntersectionObserver' in window)) {
      section.classList.add('fv-science-is-visible');
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) {
          return;
        }

        showSection(section);
        observer.unobserve(section);
      });
    }, {
      threshold: 0.2,
      rootMargin: '0px 0px -10% 0px'
    });

    observer.observe(section);
    queueInitialReveal(section);
  }

  function initSection(section) {
    if (!section) {
      return;
    }

    reveal(section);
  }

  function init() {
    document.querySelectorAll('[data-fv-science-section]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.matches('[data-fv-science-section]')
      ? event.target
      : event.target.querySelector('[data-fv-science-section]');

    if (section) {
      initSection(section);
    }
  });
})();
